import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ 'brokerSettingsRadio', 'brokerSettingsSelect' ]

  connect() {
    this.toggle()
  }

  toggle() {
    const checked = this.brokerSettingsRadioTargets.find(radio => radio.checked)?.value

    if (checked === 'allow_specific' || checked === 'block_specific') {
      this.brokerSettingsSelectTarget.classList.remove('hidden')
    } else {
      this.brokerSettingsSelectTarget.classList.add('hidden')
    }
  }
}
